import { RootState } from '../root.reducers';
import { MediaGateway } from './mediaGateway.types';

export const getMediaGatewayList = (state: RootState): MediaGateway[] =>
  state.mediaGateway.entities;

export const getMediaGateway = (state: RootState): MediaGateway | null =>
  state.mediaGateway.single;

export const getSelectedMediaGateway = (state: RootState): MediaGateway[] =>
  state.mediaGateway.selected;

export const getMediaGatewayCreatedId = (state: RootState): string | null =>
  state.mediaGateway.createdId;

export const isMediaGatewayCreatePopupOpen = (state: RootState): boolean =>
  state.mediaGateway.ui.isCreatePopupOpen;

export const isMediaGatewayLoading = (state: RootState): boolean =>
  state.mediaGateway.ui.isLoading;
